//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {},
  name: 'demo-wrap',
  data() {
    return {};
  },
  methods: {
    ...mapActions([])
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
